"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var preview_1 = tslib_1.__importDefault(require("./preview"));
var Wrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-size: ", ";\n  ", "\n  ", " {\n    margin: 0;\n    width: 100%;\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-size: ", ";\n  ",
    "\n  ", " {\n    margin: 0;\n    width: 100%;\n  }\n"])), polished_1.rem(12), function (_a) {
    var theme = _a.theme;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    margin: 0 -", ";\n    width: calc(100% + ", ");\n  "], ["\n    margin: 0 -", ";\n    width: calc(100% + ", ");\n  "])), polished_1.rem(theme.grid.gutterWidth / 2), polished_1.rem(theme.grid.gutterWidth));
}, utilities_1.mb('m'));
var MatchWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth / 4) + " " + polished_1.rem(theme.grid.gutterWidth / 2);
});
var MatchesWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  > div {\n    border-bottom: ", " solid ", ";\n  }\n"], ["\n  > div {\n    border-bottom: ", " solid ", ";\n  }\n"])), polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
});
var defaultSize = {
    innerHeight: 0,
    innerWidth: 0,
    outerHeight: 0,
    outerWidth: 0
};
function useWindowSize() {
    var _a = React.useState(defaultSize), windowSize = _a[0], setWindowSize = _a[1];
    React.useEffect(function () {
        function handleResize() {
            setWindowSize({
                innerHeight: window.innerHeight,
                innerWidth: window.innerWidth,
                outerHeight: window.outerHeight,
                outerWidth: window.outerWidth
            });
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return windowSize;
}
function useIsResponsiveLayout(breakpoint) {
    if (breakpoint === void 0) { breakpoint = 768; }
    var resizeHook = useWindowSize();
    var mobileLayout = React.useMemo(function () {
        return resizeHook.innerWidth ? resizeHook.innerWidth <= breakpoint : false;
    }, [resizeHook.innerWidth, breakpoint]);
    return mobileLayout;
}
var MatchesList = function (_a) {
    var renderLink = _a.renderLink, theme = _a.theme, matchesList = _a.matchesList;
    var mobileLayout = useIsResponsiveLayout();
    var renderMatchesList = function () { return (React.createElement(MatchesWrapper, null, matchesList.matches.map(function (match) { return (React.createElement(MatchWrapper, { key: "match-" + match._id },
        React.createElement(preview_1["default"], { view: !mobileLayout ? 'streched' : 'compact', theme: theme, match: match, renderLink: renderLink }))); }))); };
    return React.createElement(Wrapper, null, renderMatchesList());
};
exports["default"] = MatchesList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
